import { Box, Grid, Typography } from '@mui/material';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { formatMoney } from 'utils/helpers';
import { AccountingType, NewOrderPartyType } from 'v2-types/order';

import { useStyles } from '../../styles';
import { Link } from 'react-router-dom';

type Props = {
  orderAccountingEscrowEntries: AccountingType[];
  parties: NewOrderPartyType[]
}

export const EscrowAmounts: FC<Props> = ({ orderAccountingEscrowEntries, parties }) => {
  const classes = useStyles();
  const { t } = useTranslation();
  const lenders = parties?.filter(party => party.kinds.includes('Lender'));
  const buyers = parties?.filter(party => party.kinds.includes('Buyer'));
  return (
    <Box>
      <Typography variant="h6" className={classes.subTitle}>
        {t('loan:escrowAmounts')}
      </Typography>
      <Box style={{ display: "flex", flexDirection: "row", flexWrap: "wrap", gap: "16px" }}>
        {orderAccountingEscrowEntries.map((entry) => (
          <Typography key={entry._id} style={{ textTransform: "capitalize" }}>
            {entry.code.replace("_", " ")}
            :
            {' '}
            {formatMoney(entry.amount)}
          </Typography>
        ))}
      </Box>
      <Box>
        <Grid container direction="column" style={{ paddingTop: 8 }}>
          <Grid item xs={12}>
            <Grid container direction="row">
              {lenders?.map((lender, index) => (
                <React.Fragment key={lender._id}>
                  {index === lenders.length - 1 && lenders.length > 1 && (
                    <Typography style={{ fontWeight: 500, marginLeft: 4, marginRight: 4 }}>
                      {t('common:and')}
                    </Typography>
                  )}
                  <Link to={`/contacts/${lender._id}`}>
                    <Typography style={{ fontWeight: 500 }}>
                      {lender.name}
                    </Typography>
                  </Link>
                  {index < lenders.length - 2 && (
                    <Typography style={{ fontWeight: 500, marginRight: 4 }}>
                      ,
                    </Typography>
                  )}
                </React.Fragment>
              ))}
              <Typography style={{ fontWeight: 500, marginLeft: 8, marginRight: 8 }}>
                {t('loan:lendingTo')}
              </Typography>
              {buyers?.map((buyer, index) => (
                <React.Fragment key={buyer._id}>
                  {index === buyers.length - 1 && buyers.length > 1 && (
                    <Typography style={{ fontWeight: 500, marginLeft: 4, marginRight: 4 }}>
                      {t('common:and')}
                    </Typography>
                  )}
                  <Link to={`/contacts/${buyer._id}`}>
                    <Typography style={{ fontWeight: 500 }}>
                      {buyer.name}
                    </Typography>
                  </Link>
                  {index < buyers.length - 2 && (
                    <Typography style={{ fontWeight: 500, marginRight: 4 }}>
                      ,
                    </Typography>
                  )}
                </React.Fragment>
              ))}
            </Grid>
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
};
